import { render, staticRenderFns } from "./UploadTemplatePreference.vue?vue&type=template&id=04be3e55&scoped=true"
import script from "./UploadTemplatePreference.vue?vue&type=script&lang=js"
export * from "./UploadTemplatePreference.vue?vue&type=script&lang=js"
import style0 from "./UploadTemplatePreference.vue?vue&type=style&index=0&id=04be3e55&prod&lang=scss"
import style1 from "./UploadTemplatePreference.vue?vue&type=style&index=1&id=04be3e55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04be3e55",
  null
  
)

export default component.exports